<template>
  <div>
    <main class="l-content">
      <section class="l-section wpb_row height_small mpc-row">
        <div class="l-section-h i-cf">
          <div class="g-cols type_default valign_top">
            <div
              class="vc_col-sm-12 wpb_column vc_column_container mpc-column"
              data-column-id="mpc_column-645e6b576740f16"
            >
              <div class="vc_column-inner vc_custom_1491817807335">
                <div class="wpb_wrapper">
                  <div class="wpb_text_column">
                    <div class="wpb_wrapper">
                      <h1 style="text-align: center; font-size: 22px">{{ $t("Контакти") }}</h1>
                    </div>
                  </div>

                  <div class="g-cols wpb_row type_default valign_top vc_inner mpc-row">
                    <div
                      class="vc_col-sm-6 wpb_column vc_column_container mpc-column"
                      data-column-id="mpc_column-475e6b57673f8aa"
                    >
                      <div class="vc_column-inner">
                        <div class="wpb_wrapper">
                          <div class="vc_empty_space" style="height: 30px">
                            <span class="vc_empty_space_inner"></span>
                          </div>

                          <div class="wpb_text_column">
                            <div class="wpb_wrapper" v-html="pageData.description1" data-html></div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="vc_col-sm-6 wpb_column vc_column_container mpc-column"
                      data-column-id="mpc_column-445e6b576740841"
                    >
                      <div class="vc_column-inner">
                        <div class="wpb_wrapper">
                          <form @submit.prevent="onSubmit">
                            <p>
                              <BaseInput
                                v-model="inputs.name.value"
                                :error="inputs.name.error"
                                type="text"
                                :label="$t(`Ваше ім'я`)"
                              />
                            </p>

                            <p>
                              <BaseInput
                                v-model="inputs.email.value"
                                :error="inputs.email.error"
                                type="email"
                                :label="$t(`Ваш email`)"
                              />
                            </p>
                            <p>
                              <BaseInput
                                type="tel"
                                v-model="inputs.phone.value"
                                :error="inputs.phone.error"
                                mask="+38 (099) 999-99-99"
                                placeholder="+38 (0__) ___-__-__"
                                :label="$t('Номер телефону')"
                              />
                            </p>
                            <p>
                              <BaseInput
                                v-model="inputs.text.value"
                                :error="inputs.text.error"
                                textarea
                                :label="$t(`Ваше питання`)"
                              />
                            </p>
                            <BaseAlertInline :value="overallErrorsMix" class="_warning" />
                            <p>
                              <button type="submit" class="base-btn _black">
                                {{ $t("Надіслати") }}
                              </button>
                            </p>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--      <section class="l-section wpb_row height_small mpc-row">-->
      <!--        <div class="l-section-h i-cf">-->
      <!--          <div class="g-cols type_default valign_top">-->
      <!--            <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column"-->
      <!--                 data-column-id="mpc_column-895e6b576794d5b"-->
      <!--            >-->
      <!--              <div class="vc_column-inner">-->
      <!--                <div class="wpb_wrapper">-->
      <!--                  <div data-id="mpc_map-375e6b576741861"-->
      <!--                       class="mpc-map-wrap  mpc-custom-height"-->
      <!--                  ><p-->
      <!--                    class="mpc-error"-->
      <!--                  >If-->
      <!--                    you see this Google Maps wasn't properly loaded. Please refresh your page 🙂</p>-->
      <!--                    <GoogleMap/>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </section>-->
    </main>
  </div>
</template>

<script>
// import GoogleMap from '../components/GoogleMap'
import { http } from "../axios";
import formMixins from "../mixins/formMixins";

export default {
  name: "Contacts",
  // components: {GoogleMap},
  mixins: [formMixins],
  data() {
    return {
      pending: false,
      inputs: {
        name: {
          value: null,
        },
        phone: {
          value: null,
        },
        email: {
          value: null,
        },
        text: {
          value: null,
        },
      },
    };
  },
  computed: {
    pageData() {
      return this.$store.state.page.pageData;
    },
  },
  methods: {
    onSubmit() {
      this.resetErrorsMix(this.inputs);
      const sendData = this.createSendDataMix(this.inputs);
      if (!sendData) return;

      if (sendData.phone) {
        sendData.phone = `380${sendData.phone}`;
      }

      http
        .post("api/feedback/feedback-apply", sendData)
        .then((data) => {
          this.$nextTick(() => {
            this.$vModal.open("message", {
              title: data.data.message,
              type: data.data.status,
            });

            for (let item in this.inputs) {
              this.inputs[item].value = null;
            }
          });
        })
        .catch((e) => {
          this.handlerErrorMix(e, this.inputs);
        });
    },
  },
};
</script>

<style></style>
